import { DeviceResponse, DeviceStatus } from 'api/Responses/DeviceResponses';
import axiosInstance from 'services/APIService';

const ENDPOINT_PATH = `/v1/device`;
const ENDPOINT_PATH_V2 = `/v2/device`;

/*
 * Gets a device given an ID
 */
export const get = async (id: string): Promise<DeviceResponse> => {
  const response = await axiosInstance.get<DeviceResponse>(`${ENDPOINT_PATH}/part/${id}`);
  return response.data;
};

/*
 * Gets a device given an ID
 */
export const getV2 = async (id: string): Promise<DeviceResponse> => {
  const response = await axiosInstance.get<DeviceResponse>(`${ENDPOINT_PATH_V2}/part/${id}`);
  return response.data;
};

/*
 * List all draft devices
 */
export const list = async (): Promise<string[]> => {
  const response = await axiosInstance.get<string[]>(`${ENDPOINT_PATH}/part_list`);
  return response.data;
};

/*
 * List all pending devices
 */
export const listPending = async (): Promise<string[]> => {
  const response = await axiosInstance.get<string[]>(`${ENDPOINT_PATH}/pending_parts`);
  return response.data;
};

/*
 * Updates a device with information from the body
 */
export const update = async (device: DeviceResponse): Promise<void> => {
  await axiosInstance.post<void>(`${ENDPOINT_PATH}/part`, { ...device });
};

/*
 * Updates a device image
 */
export const updateImage = async (id: string, url: string): Promise<void> => {
  await axiosInstance.put<void>(`${ENDPOINT_PATH}/update_image/${id}`, { url });
};

/*
 * Submits a device for review
 */
export const submit = async (id: string, status: DeviceStatus): Promise<void> => {
  await axiosInstance.put<void>(`${ENDPOINT_PATH}/part_draft?part_id=${id}&status=${status}`);
};

/*
 * Merges a device into the DB
 */
export const merge = async (id: string): Promise<void> => {
  await axiosInstance.put<void>(`${ENDPOINT_PATH}/part?part_id=${id}`);
};

/*
 * Remove a device from the draft list
 */
export const remove = async (id: string): Promise<void> => {
  await axiosInstance.delete<void>(`${ENDPOINT_PATH}/part?part_id=${id}`);
};
